<template>
  <div>
    <div class="loginWrapper">
      <div class="containerSingleBox">
        <!--Login box -->
        <div class="loginBox background-white">
          <div class="logo">
            <img src="@/assets/images/up.svg" />
            <p v-if="!dataLoaded">
              <span v-html = '$t("affiliateInvoicesTitle1")'></span>
            </p>
            <p v-else-if="this.affiliateBalance > 0">
              <span v-html = '$t("affiliateInvoicesTitle3")'></span>
              <span :class="this.affiliateBalance > 0 ? 'culoare-13' : 'culoare-15'"> {{ this.affiliateBalance +
                $t("currency") }}</span>
                <br />
              <a class="button-orange" @click="payAll()">{{ $t("payAllLabel") + " (" + this.affiliateBalance +
                $t("currency") + ")" }}</a>
            </p>
            <p v-if="affiliateInvoicesError" class="loginError" >
              <span v-html = '$t("affiliateInvoicesErrorMessage")'></span>
            </p>
          </div>
          <br/>
          <div class="loginForm">
            <form
              v-if="!dataLoaded"
              @submit.prevent="getInfoForAffiliate()"
            >
              <div>
                <div class="password">
                  <input :placeholder="[[$t('fiscalCodeLabel')]]"  v-model="fiscalCode" required
                  class="formedituser"
                    type='text'
                      />
                </div>
<br />
                <input
                  type="submit"
                  :value="[[$t('confirmButtonLabel')]]"
                  variant="primary"
                  class="submitCompanies"
                />
              </div>
            </form>
            <div v-else class="height-200" >
              <table cellpadding="10" cellspacing="0" width="95%" class="hover-table invoices-table" align="center">
                <thead>
                  <tr>
                    <td></td>
                    <!-- <td valign="middle">
                      <strong>{{ $t("invoiceDownloadPDFShortHeader") }}</strong>&nbsp;
                    </td>  -->
                    <td valign="middle">
                      <strong>{{ $t("invoiceDownloadPDFHeader") }}</strong>&nbsp;
                    </td>
                    <td class="priority-2" valign="middle">
                      <strong>{{ $t("invoiceDateHeader") }}</strong>&nbsp;
                    </td>
                    <!-- <td class="priority-4" valign="middle">
                      <strong>{{ $t("invoiceStatusHeader") }}</strong>&nbsp;
                    </td> -->
                    <td  valign="middle">
                      <strong>{{ $t("invoiceAmountHeader") }}</strong>&nbsp;
                    </td>
                    <td class="priority-5" valign="middle">
                      <strong>{{  $t("invoicesFilterProduct" ) }}</strong>&nbsp;
                    </td>
                    <!-- <td v-if="userRoleInvTable === 'AFF' || userRoleInvTable === 'AFA' || userRoleInvTable === 'MTB' " class="priority-4" valign="middle">
                      <strong>{{ $t("invoiceDownloadEXLHeader") }}</strong>&nbsp;
                    </td> -->
                    <!-- <td valign="middle"></td> -->
                    <td valign="middle" ><strong>{{ $t("invoiceStatusHeader") }}</strong>&nbsp;</td>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="this.affiliateInvoices === null || this.affiliateInvoices === undefined
                    ">
                    <td colspan="12">
                      <div class="loading">
                        <img src="@/assets/images/loading.gif" />
                      </div>
                    </td>
                  </tr>
                  <tr v-if="this.affiliateInvoices.length === 0">
                    <td colspan="10">{{ $t("noInvoicesMessage") }}</td>
                  </tr>
                  <template v-for="(invoice, index) in affiliateInvoices">
                    <tr :key="index" class="trhover parent" :class="index % 2 === 0 && 'gri-cell'">
                      <td valign="middle" >
                        <a class="detailsOrderMobile priority-show-5 display-inline-block" @click="selectInvoiceMobile(index)">
                          <font-awesome-icon icon="minus-circle" v-if="detailsMobile && invoice === invoiceSelectedMobile" />
                          <font-awesome-icon icon="plus-circle" v-else />
                        </a>
                     </td>
                      <!-- <td valign="middle" style="min-width: 90px">
                        <a class="invoice-icon cursor-pointer" title="Descarca pdf" @click="downloadInvoiceFile(invoice.id, invoice.invoice)" >&nbsp;</a>
                      </td> -->
                      <td valign="middle">
                          <a class="download-href cursor-pointer" :title="invoice.invoice" @click="downloadInvoiceFile(invoice.id, invoice.invoice)" >{{ invoice.invoice }}</a>

                        </td>
                      <td valign="middle" class="priority-2">
                        {{ displayDate(invoice.date) }}
                      </td>
                      <!-- <td valign="middle" class="priority-4">
                        <span class="status-background" :class="selectColorStatus(invoice.status)" >{{ $t("invoiceStatus_" +
                          invoice.status) }}</span>
                      </td> -->
                      <td valign="middle" style="min-width: 110px">
                        {{ invoice.amount }} {{ $t("currency") }}
                      </td>
                      <td valign="middle" class="priority-5">
                        <strong >{{ invoice.product.name  }}</strong>
                      </td>
                      <!-- <td v-if="userRoleInvTable === 'AFA' || userRoleInvTable === 'AFF' " valign="middle" class="priority-4">
                        <a v-if="invoice.product.card > 0" class="invoice-excel-icon cursor-pointer"
                          @click="downloadInvoiceExcelFile(invoice)">&nbsp;</a>
                      </td> -->

                      <td valign="middle" >
                        <a
                         v-if="invoice.status !== 'V' && invoice.status !== 'L' && invoice.status !== 'R' && invoice.status !== 'P' &&
                          invoice.amount >= 0 &&
                          invoice.product.card !== 0
                          "
                           class="action-button" @click="payInvoice(invoice)">
                          <span>{{ $t("payInvoiceButtonLabel") }}</span>
                        </a>
                        <span v-else class="status-background" :class="selectColorStatus(invoice.status)" >{{ $t("invoiceStatus_" +
                          invoice.status) }}</span>
                      </td>
                    </tr>
                    <tr :key="index + affiliateInvoices.length" class="child" :class="index % 2 === 0 && 'gri-cell'"
                      v-show="detailsMobile && invoice === invoiceSelectedMobile">
                      <td colspan="12">
                        <p class="priority-show-1">
                          <strong>{{ $t("invoiceDateHeader") }} : &nbsp;&nbsp;</strong>
                          <span>{{ displayDate(invoice.date)   }}</span>
                        </p>
                        <p class="priority-show-4" >
                          <strong>{{ $t("invoiceStatusHeader") }} : &nbsp;&nbsp;</strong>
                          <span class="status-background" :class="selectColorStatus(invoice.status)">{{ $t("invoiceStatus_" +
                            invoice.status) }}</span>
                        </p>
                        <!-- <p class="priority-show-3">
                          <strong>{{ $t("invoiceAmountHeader") }} : &nbsp;&nbsp;</strong>
                          <span>{{ invoice.amount }} {{ $t("currency") }}</span>
                        </p> -->
                        <p class="priority-show-5">
                          <strong>{{ $t("invoicesFilterProduct") }} : &nbsp;&nbsp;</strong>
                          <span>
                            {{ invoice.product.name }}
                            <!-- <a class="invoice-icon cursor-pointer" @click="downloadInvoiceFile(invoice.id, invoice.invoice)">&nbsp;</a> -->
                          </span>
                        </p>
                        <!-- <p v-if="(userRoleInvTable === 'AFF' || userRoleInvTable === 'AFA') &&
                          invoice.product.card > 0
                          " class="priority-show-4">
                          <strong>{{ $t("invoiceDownloadEXLHeader") }} : &nbsp;&nbsp;</strong>
                          <span>
                            <a class="invoice-icon cursor-pointer" @click="downloadInvoiceExcelFile(invoice)">&nbsp;</a>
                          </span>
                        </p> -->
                        
                      </td>
                    </tr>
                  </template>
                </tbody>
              </table>
              <br />
            </div>
          </div>
          <div  v-if="this.dataLoaded"  class="contact flex-column">
           <div class="icon">
              <!-- <a class="button-white"  href="https://app.uponline.ro/doc/ro/GhidUpOnlineAfiliat.pdf" target="_blank">{{ $t("onlineGuideLabel") }}</a> -->
              <span class="button-white" v-html = '$t("affiliateBankAccountsMessage")'></span>
            </div>
       
            <!-- <div style=" width: 100%;
            text-align: left;">
            <a class="button-white" href="https://app.uponline.ro/doc/ro/GhidUpOnlineAfiliat.pdf" target="_blank">{{
            $t("onlineGuideLabel")
            }}</a> -->
            <table class="bank-table">
              <tr><th>
                Banca
              </th>
              <th>
                Cont
              </th>
              </tr>
              <template v-for="account in bankAccounts"
              
              >
              <tr :key="account.bankBranch">
                <td>{{ account.bankBranch }}</td>
                <td>

                  {{ account.iban }}
                </td>
              </tr>
              </template>
            </table>
            </div> 
            <br />
          <div v-if="this.dataLoaded"  class="contact">
             <div class="icon">
                <a class="button-white"  href="https://app.uponline.ro/doc/ro/GhidUpOnlineAfiliat.pdf" target="_blank">{{ $t("onlineGuideLabel") }}</a>
            </div>
          </div>

          <div class="contact">
            <div class="contact-item">
             <div class="icon">
                  <img src="@/assets/images/support.svg" /> 
                <a >{{ affiliateSupport.contact }}</a>
              </div>
            </div>
            <div class="contact-item">
              <div class="icon">
                <img src="@/assets/images/phone.svg" />
                <a :href="'tel:' + affiliateSupport.phone">{{ affiliateSupport.phone }}</a>
              </div>
            </div>
            <div class="contact-item">
              <div class="icon">
                <img src="@/assets/images/chat.svg" />
                <a :href="'mailto:' + affiliateSupport.email">{{ affiliateSupport.email }}</a>
              </div>
            </div>
          </div>

        </div>
        <!--End Login box -->
      </div>
    </div>
    <div id="modal_popup_loading" class="modal-popup">
      <div class="modal-popup-content">
        <img src="@/assets/images/loading.gif" />
        <p v-html="$t('loadingPopupMessage')">
        </p>
      </div>
    </div>
    <div id="modal_popup_info" class="modal-popup">
      <div class="modal-popup-content">
        <a @click="showModalPopup('modal_popup_info', false)" class="close-button">
          <img src="@/assets/images/close-button.svg" />
        </a>
         <div v-if="this.downloadInvoicesError">
          <p v-html="$t('errorMessage_' + this.downloadInvoicesError.code)"></p>
        </div>
         <div v-if="paymentInvoicesError || paymentInvoicesSuccess">
          <div v-if="paymentInvoicesError">
            <p v-if="paymentInvoicesError.error_code">
              {{
                $t(paymentInvoicesError.error_code, {
                  name: paymentInvoicesError.description
                })
              }}
            </p>
            <p v-else>{{ $t("errorRedirectPaymentMessage") }}</p>
          </div>
          <div v-else>
            <p>{{ $t("redirectPaymentMessage") }}</p>
          </div>
      </div>
      </div>
    </div>
  </div>
</template>

<script>
  import utils from "@/plugins/utils.js";
  import httpServiceUser from "@/http/http-user.js";
  import httpServiceCommon from "@/http/http-common.js";
  import httpServiceCustomer from "@/http/http-customer.js";
  import httpServiceAffiliate from "@/http/http-affiliate.js";
  import { saveAs } from "file-saver";
  import moment from "moment";
  export default {
    name: "affiliate_payment_notice",
    data() {
      return {
        uuid: null,
        month: null,
        affiliateInvoices: null,
        affiliateSupport: null,
        affiliateBalance: null,
        bankAccounts: null,
        fiscalCode: "",
        token: null,
        config: JSON.parse(sessionStorage.getItem("affiliate_jsonFile")),
        dataLoaded: false,
        affiliateInvoicesError: false,
        downloadInvoicesError: null,
        paymentInvoicesError: null,
        paymentInvoicesSuccess: false,
        detailsMobile: false,
        invoiceSelectedMobile: null,
      };
    },
    methods: {
      getInfoForAffiliate() {
        this.resetSupport();
        this.getBankAccounts();
        this.getInvoicesForAffiliate();
      },
      resetSupport() {
        this.affiliateSupport = {
          contact: "Suport Afiliati",
          phone: "021.402.82.23",
          email: "afiliati@upromania.ro"
        }
      },
      displayDate(date) {
        return moment(new Date(date), "YYYY-MM-DDThh:mm:ss").format("DD/MM/YYYY");
      },
      getInvoicesForAffiliate() {
        let uuidLink = "?uuid=" + this.uuid + "&fiscal_code=" + this.fiscalCode.trim() + "&per_page=100&page=1";
        this.affiliateInvoicesError = false;
        this.dataLoaded = false;
        this.affiliateInvoices = [];
        this.showModalPopup("modal_popup_loading", true);
        httpServiceUser.userService
          .getNotificationInvoicesForAffiliate(uuidLink, this.token)
          .catch(error => {
            return error.response
          })
          .then(response => {
            if (response.status == 200) {
              this.affiliateInvoices = response.data;
              this.showModalPopup("modal_popup_loading", false);
              this.getSupportForAffiliate();
              this.getAffiliateBalance();
            } else if (response.status == 400){
              this.affiliateInvoicesError = true;
              // this.affiliateInvoices = []
            } else {
              // this.showModalPopup("modal_popup_info", true);
            }
            this.showModalPopup("modal_popup_loading", false);
          });
      },
      getSupportForAffiliate() {
        let params = "?token=" + this.fiscalCode.trim();

        httpServiceUser.userService
          .getAffiliateSupportPerson(params, this.token)
          .catch(error => {
            return error.response
          })
          .then(response => {
            if (response.status == 200) {
              this.affiliateSupport = response.data;
            } else {
              this.resetSupport();
              // this.showModalPopup("modal_popup_info", true);
            }
          });
      },
            selectInvoiceMobile(index) {
        this.invoiceSelectedMobile = this.affiliateInvoices[index];
        this.detailsMobile = !this.detailsMobile;
      },
      getAffiliateBalance() {
        httpServiceUser.userService
          .getAffiliateBalance(this.fiscalCode.trim(), this.token)
          .catch(error => {
            return error.response
          })
          .then(response => {
            if (response.status == 200) {
              this.affiliateBalance = response.data.balance;
            } else {
              this.resetSupport();
              // this.showModalPopup("modal_popup_info", true);
            }
                          this.dataLoaded = true;

          });
      },
      getBankAccounts() {
        httpServiceUser.userService
          .getBankAccountsForAffiliatePayment(this.token)
          .catch(error => {
            return error.response
          })
          .then(response => {
            if (response.status == 200) {
              this.bankAccounts = response.data;
            } else {
            }
          });
      },
      getTokenForValidateCredentials() {
        httpServiceCommon.companyService
          .requestTokenForRegistration("webopen")
          .then(function (response) {
            // handle success
            return response.data;
          })
          .then(data => {
            this.token = data.access_token;
          })
          .catch(error => {
            // handle error
          });
      },
      payInvoice(invoice) {
        this.sendPaymentInfo(invoice.from_source_id, [
          {
            invoice: invoice.invoice,
            from_source_id: invoice.id,
            amount: invoice.amount,
            date: invoice.date
          }], invoice.amount);

      },
      payAll() {
        this.sendPaymentInfo(this.affiliateInvoices[0].from_source_id, this.affiliateInvoices, this.affiliateBalance);
      },
      sendPaymentInfo(companyCode, invoicesForPayment, amountForPayment) {
        this.paymentInvoicesError = null;
        this.paymentInvoicesSuccess = false;
        this.downloadInvoicesError = null;
        this.showModalPopup("modal_popup_loading", true);

        let payload = {
          payment: {
            user: 0,
            client_account: companyCode,
            client_fiscal: this.fiscalCode.trim(),
            invoices: invoicesForPayment,
            amount: amountForPayment
          }
        }
        httpServiceAffiliate.affiliateService
          .payInvoices(companyCode, payload, this.token)
          .catch(error => {
            return error.response;
          })
          .then(response => {
            if (response.status === 200) {
              this.paymentInvoicesSuccess = true;
              this.paymentInvoicesError = null;
              // this.totalAmount = this.totalPayment;
              this.showModalPopup("modal_popup_loading", false);
              this.showModalPopup("modal_popup_info", true);
              this.redirectToPaymentPage(response.data);
              // this.resetAndClose();
            } else if (response.status === 400 || response.status === 403) {
              this.paymentInvoicesError = response.data;
              this.showModalPopup("modal_popup_loading", false);
              this.showModalPopup("modal_popup_info", true);
            } else {
              this.paymentInvoicesError = {};
              this.showModalPopup("modal_popup_loading", false);
              this.showModalPopup("modal_popup_info", true);
            }
          })
      },
      redirectToPaymentPage(response) {
        let url = process.env.VUE_APP_NETOPIA_PAYMENT;
        let params = {
          env_key: response.envelope,
          data: response.data
        };
        utils.openWindowWithPost(url, params);
      },
      getErrorMessage(code) {
        let config = JSON.parse(sessionStorage.getItem("mobile_jsonFile"));
        return config.errors[code];
      },
      redirectToLogin() {
        this.showModalPopup("modal_popup_info", false);
        this.$router.push({
          name: "affiliate_invoices",
          // params: { loginUserSelected: false }
        });
      },
      downloadInvoiceFile(invoiceId, invoiceNumber, isExcel) {
        this.showModalPopup("modal_popup_loading", true);
        let link = "/v1/affiliate_invoices/" + invoiceId + "/pdf" ;
         this.downloadInvoicesError = null;
        httpServiceCustomer.customerService
          .getOrderDocumentFile(link,  this.token , false)
          .then(function (response) {
            return response;
          })

          .then(response => {
            if (response.status == 200) {
              this.showModalPopup("modal_popup_loading" ,false);
              let content = response.data.response.eInvoicePdf ;
              var blob = new Blob(
                [utils.base64ToArrayBuffer(content)],
                {
                  type:
                    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheetapplication/vnd.ms-excel"
                }
              );
              saveAs(blob, invoiceNumber + (isExcel ? ".xls" : ".pdf"));
              this.downloadInvoicesError = null;
            } else if (response.status == 400 || response.status == 403) {
              this.downloadInvoicesError = { code: response.status };
              this.deliveryAddresses = null;
              this.showModalPopup("modal_popup_loading" ,false);
              this.showModalPopup("modal_popup_info", true);
            } else if (response.status == 404) {
              this.downloadInvoicesError = { code: response.status };
              this.showModalPopup("modal_popup_loading" ,false);
              this.showModalPopup("modal_popup_info", true);
            } else {
              this.downloadInvoicesError = { code: "503" };
              this.showModalPopup("modal_popup_loading" ,false);
              this.showModalPopup("modal_popup_info", true);
            }
          })
          .catch(error => {
            this.downloadInvoicesError = { code: "503" };
            this.deliveryAddresses = null;
            this.showModalPopup("modal_popup_loading" ,false);
            this.showModalPopup("modal_popup_info", true);
          });
      },
      selectColorStatus(status) {
        switch (status) {
          case "P":
          case "L":
          case "R":
            return "background-active";
          case "U":
          case "Not paid":
            return "background-will-expire";
          case "O":
            return "background-suspended";
          default:
            return "background-will-expire";
        }
      },
      showModalPopup(elementId, show) {
        if (show) {
          document.getElementById(elementId).style.visibility = "visible";
        } else {
          document.getElementById(elementId).style.visibility = "hidden";
        }
      },
    },
    mounted() {
      this.uuid = utils.getUrlParam("uuid");
      this.month = Number(utils.getUrlParam("month"));
      this.resetSupport();
      this.getTokenForValidateCredentials();
    },
    computed: {
      confirmPasswordStyle() {
        return this.confirmPassword === ""
          ? ""
          : this.newPassword === this.confirmPassword
            ? ""
            : "outline-color: #ff0000a6;";
      }
    }
  };
</script>
<style scoped src="@/assets/styles/login.css"></style>
<style scoped>
.culoare-13 {
	color: #c61b10;
}

.culoare-15 {
	color: #98cb00;
}

  .height-200{
    height: 200px;
    overflow: scroll;
  }

  .bank-table{
    width:70%;
  }

  .bank-table td, th{
    padding-left: 5px;
    border: 1px black solid;
  }

  .loginForm input[type="submit"].mandate-button {
    width: 50%;
    height: 30px;
    padding: 0 30px;
  }

  .loginForm {
    width: 90%;
    text-align: center;
  }

  .loginForm input[type="submit"][data-v-42f29d14] {
    width: 50%;
  }

  .containerSingleBox {
    min-width: 680px;
    min-width: -webkit-fill-available;

    width: auto;
    ;
  }

  .contact {
    border-top: 1px solid #ddd;
    /* margin-top: 20px; */
    width: 100%;
    display: flex;
    justify-content: space-around;
    align-items: center;
  }

.contact-item {
	grid-template-columns: 15% auto;
	margin-top: 20px;
	align-items: top;
}

.contact-item .icon {
	text-align: center;
  padding-right: 10px;
}

.icon img {
  padding-right: 10px ;
}

  .button-orange {
    display: inline-block;
    width: auto;
    padding: 10px;
    font-size: 12px;
    background: #f49400;
    color: #fff;
    text-decoration: none;
    border-radius: 5px;
    text-transform: uppercase;
    font-weight: bold;
    text-align: center;
    margin: 10px 5px;
    cursor: pointer;
  }

  .button-white {
    display: inline-block;
    width: auto;
    padding: 10px;
    font-size: 14px;
    background: #fff;
    color: #2a2a2a;
    text-decoration: none;
    border-radius: 5px;
    /* text-transform: uppercase; */
    font-weight: bold;
    text-align: center;
    margin: 10px 5px;
    cursor: pointer;
  }

  .invoices-table .status-background {
	padding: 2px 7px;
	font-size: 13px;
}

.status-background {
	display: inline-block;
	width: auto;
	text-align: center;
	color: #fff;
	border-radius: 5px;
	padding: 2px 15px;
	font-size: 14px;
}

.background-active {
	background: #05c591;
}

.background-will-expire {
	background: #f59100;
}

.background-suspended {
	background: #4e5b59;
}
.download-href {
  color: #0B8F6C;
  /* font-; */
}

.invoices-table a:hover{
  text-decoration: underline !important;
  
}

.download-href :hover {
  text-decoration: underline !important;
  color:#0B8F6C;
}

.priority-show-0,
.priority-show-1,
.priority-show-2,
.priority-show-3,
.priority-show-4,
.priority-show-5,
.priority-show-6 {
	display: none;
}

@media (max-width: 1680px) {
	table .child > td {
		display: table-cell;
	}
	.priority-6 {
		display: none;
	}
	.priority-show-6 {
		display: block;
	}
	.priority-show-6.display-inline-block {
		display: inline-block;
	}
}


@media (max-width: 1200px) {
	.priority-5 {
		display: none;
	}
	.priority-show-5 {
		display: block;
	}
	.priority-show-5.display-inline-block {
		display: inline-block;
	}
}


@media (max-width: 1024px) {
	.priority-4 {
		display: none;
	}
	.priority-show-4 {
		display: block;
	}
	.priority-show-4.display-inline-block {
		display: inline-block;
	}
}

@media (max-width: 860px) {
	.priority-3 {
		display: none;
	}
	.priority-show-3 {
		display: block;
	}
	.priority-show-3.display-inline-block {
		display: inline-block;
	}
}

@media (max-width: 600px) {
	.priority-2 {
		display: none;
	}
	.priority-show-2 {
		display: block;
	}
	.priority-show-2.display-inline-block {
		display: inline-block;
	}
	#modal_popup_detailsReimbursements .modal-popup-content {
		width: 80%;
		max-width: none;
	}
}

@media (max-width: 480px) {
	.priority-1 {
		display: none;
	}
	.priority-show-1 {
		display: block;
	}
	.priority-show-1.display-inline-block {
		display: inline-block;
	}
}


@media (max-width: 400px) {
	.priority-0 {
		display: none;
	}
	.priority-show-0 {
		display: block;
	}
	.priority-show-0.display-inline-block {
		display: inline-block;
	}
}
</style>
